import React, { createContext, useState, useContext } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => { 
  const [searchQuery, setSearchQuery] = useState("");

  // Arama kutusunu temizlemek için yardımcı bir fonksiyon
  const clearSearch = () => setSearchQuery("");

  return (
    <SearchContext.Provider value={{ searchQuery, setSearchQuery, clearSearch }}>
      {children}
    </SearchContext.Provider>
  );
};

// Kolay kullanım için Custom Hook
export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearch mutlaka SearchProvider içinde kullanılmalıdır.");
  }
  return context;
};